const STRONG_CODE_REGEX = /\b[HG]\d{1,5}\b/i;

/** Extracts a Strong code (H1234 / G5678) from an anchor's href or text. */
export function extractStrongCode(anchor: HTMLAnchorElement): string | null {
  const href = anchor.getAttribute("href") ?? "";
  const fromHref = STRONG_CODE_REGEX.exec(href)?.[0];
  if (fromHref) {
    return fromHref.toUpperCase();
  }
  // `Node.textContent` es `string | null` en runtime (DOM); el `?? ""` evita
  // pasar null a exec(). El type-checker lo infiere como non-null aquí, pero
  // mantenemos la guarda defensiva por seguridad en runtime.
  // oxlint-disable-next-line typescript/no-unnecessary-condition -- textContent es nullable en runtime
  const fromText = STRONG_CODE_REGEX.exec(anchor.textContent ?? "")?.[0];
  return fromText ? fromText.toUpperCase() : null;
}

/**
 * Click handler for containers that render trusted Strong's definition HTML.
 * Cross-references between entries are plain anchors; following them would
 * navigate the SPA away, so we intercept the click and resolve the referenced
 * code in-place instead.
 */
export function handleDefinitionLinkClick(e: MouseEvent, onCode: (code: string) => void): void {
  const { target } = e;
  if (!(target instanceof Element)) {
    return;
  }
  const anchor = target.closest("a");
  if (!anchor) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();

  const code = extractStrongCode(anchor);
  if (code) {
    onCode(code);
  }
}
